var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMediasPostSizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_611_532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7051 19.3146H27.0299C25.8538 19.3146 24.8008 18.6552 24.2812 17.6112L23.8162 16.677C22.941 14.9186 21.1906 13.8334 19.235 13.8334H16.2949C13.4641 13.8334 11.1667 16.1413 11.1667 18.9849V31.3485C11.1667 34.1922 13.4641 36.5 16.2949 36.5H32.7051C35.5359 36.5 37.8333 34.1922 37.8333 31.3485V24.4798C37.8333 21.6362 35.5359 19.3283 32.7051 19.3283V19.3146ZM35.782 31.3348C35.782 33.0382 34.4008 34.4257 32.7051 34.4257H16.2949C14.5991 34.4257 13.2179 33.0382 13.2179 31.3348V18.9712C13.2179 17.2677 14.5991 15.8802 16.2949 15.8802H19.235C20.4111 15.8802 21.4641 16.5396 21.9838 17.5837L22.4487 18.5178C23.3239 20.2762 25.0744 21.3615 27.0299 21.3615H32.7051C34.4008 21.3615 35.782 22.7489 35.782 24.4524V31.321V31.3348Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_611_532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediasPostSizer);
export default __webpack_public_path__ + "static/media/mediasPostSizer.d614598c.svg";
export { ForwardRef as ReactComponent };